import React, {useEffect, useState} from 'react'

import 'lazysizes';

import CentralVirtual from './Components/Organisms/Personas/CentralVirtual'

import { PlanesService, FiltroService, CategoriesService, ChannelsService  } from "./actions/HttpCalls";
import { HttpClient } from "./actions/HttpClient";

const httpClient = new HttpClient();
const planesService = new PlanesService(httpClient);
const filtroService = new FiltroService(httpClient);
const categoriesService = new CategoriesService(httpClient);
const channelsService = new ChannelsService(httpClient);



function ClaroApp () {
    const [filTipoCentral, setFilTipoCentral] = useState([])
    const [filTipoPlan, setFilTipoPlan] = useState([])
    const [filVelocidad, setFilVelocidad] = useState([])
    const [dataCPlanesBK, setdataCPlanesBK] = useState([])
    const [dataCategoriasBk, setDataCategoriasBk] = useState([])
    const [dataChannelsBk, setDataChannelsBk] = useState([])

    const getValuesDefault = async () => {
        let fTypeCentral = await filtroService.getFiltroItems({fi_filtro:25})
        //let fTypeCentral = await filtroService.getFiltroItems({fi_filtro:16})
        setFilTipoCentral(fTypeCentral)

        let fTypePlan = await filtroService.getFiltroItems({fi_filtro:26})
        //let fTypePlan = await filtroService.getFiltroItems({fi_filtro:17})
        setFilTipoPlan(fTypePlan)

        let fVelocidad = await filtroService.getFiltroItems({fi_filtro:27})
        //let fVelocidad = await filtroService.getFiltroItems({fi_filtro:18})
        setFilVelocidad(fVelocidad)
        let paramFamilia = localStorage.getItem("id_familia");
        let paramServicio = localStorage.getItem("fi_servicio");
        let paramCategoria = localStorage.getItem("fi_categoria");
        let bodyParams;
        let planes;
        if(paramCategoria !== null && paramCategoria !== undefined && paramCategoria !== '') {
            bodyParams = { fi_categoria: paramCategoria }
            planes = await planesService.getCPlanesCategoria(bodyParams)
        } else if (paramServicio !== null && paramServicio !== undefined && paramServicio !== '') {
            bodyParams = { fi_servicio: paramServicio }
            planes = await planesService.getCPlanesServicio(bodyParams)
        } else {
            bodyParams = { fc_familia: paramFamilia }
            planes = await planesService.getCPlanesFamilia(bodyParams)
        }		
		setdataCPlanesBK(planes)

        console.log("Tipo Central::", fTypeCentral)
        console.log("Tipo Plan::", fTypePlan)
        console.log("Velocidad::", fVelocidad)
        console.log("planes::", planes)
	};
    const getValuesChannels = async () => {
		
		let flagModChannel = localStorage.getItem('flagModChannel') === "CHN" ? true : false;
		if(flagModChannel){
			const channels = await channelsService.getChannelsItems()
			setDataChannelsBk(channels)
			
			const categories = await categoriesService.getCategoriesItems()
			setDataCategoriasBk(categories)

			console.log("channels", channels)
			console.log("categories", categories)
		}
	};
	
	useEffect(()=>{
		getValuesDefault()
        getValuesChannels()
		// eslint-disable-next-line
	},[])
    return (
        <>
            <CentralVirtual
                filTipoCentral={filTipoCentral}
                filTipoPlan={filTipoPlan}
                filVelocidad={filVelocidad}
                dataCPlanesBK={dataCPlanesBK}
                dataChannelsBk={dataChannelsBk}
                dataCategoriasBk={dataCategoriasBk}
            />
        </>
    )
}

export default ClaroApp